import React from "react";
import { useTranslation } from "react-i18next";
import { UserFilters as Filters } from "../../types";
import Button from "../UI/Button";

interface UserFiltersProps {
  filters: Filters;
  onFiltersChange: (filters: Partial<Filters>) => void;
  onClearFilters: () => void;
  setShowFilters: React.Dispatch<React.SetStateAction<boolean>>;
  roleOptions?: { value: string; label: string }[];
}

export const UserFilters: React.FC<UserFiltersProps> = ({
  filters,
  onFiltersChange,
  onClearFilters,
  setShowFilters,
  roleOptions,
}) => {
  const { t } = useTranslation("users");

  const statusOptions = [
    { value: "active", label: t("filters.statusOptions.active") },
    { value: "inactive", label: t("filters.statusOptions.inactive") },
    { value: "pending", label: t("filters.statusOptions.pending") },
  ];

  const hasActiveFilters = !!filters.status || !!filters.role;

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6 space-y-6">
      <div className="space-y-2 pb-2 border-b border-gray-200">
        <div className="space-y-2">
          {roleOptions && roleOptions.length > 0 && (
            <div className="space-y-2 pb-2 border-b border-gray-200">
              <label className="block text-sm font-medium text-gray-700">
                {t("filters.role")}
              </label>
              <div className="space-y-2">
                {roleOptions.map((option) => (
                  <label key={option.value} className="flex items-center">
                    <input
                      type="radio"
                      name="role"
                      value={option.value}
                      checked={filters.role === option.value}
                      onChange={(e) =>
                        onFiltersChange({
                          role: e.target.value as Filters["role"],
                        })
                      }
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                    />
                    <span className="ml-2 text-sm text-gray-700">
                      {option.label}
                    </span>
                  </label>
                ))}
              </div>
            </div>
          )}
          <label className="block text-sm font-medium text-gray-700">
            {t("filters.status")}
          </label>
          {statusOptions.map((option) => (
            <label key={option.value} className="flex items-center">
              <input
                type="radio"
                name="status"
                value={option.value}
                checked={filters.status === option.value}
                onChange={(e) => onFiltersChange({ status: e.target.value })}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
              />
              <span className="ml-2 text-sm text-gray-700">{option.label}</span>
            </label>
          ))}
        </div>
      </div>
      <div className="flex justify-between">
        {hasActiveFilters && (
          <Button variant="outline" size="sm" onClick={onClearFilters}>
            {t("filters.clearAll")}
          </Button>
        )}
        <Button
          onClick={() => setShowFilters(false)}
          size="sm"
          variant="primary"
        >
          {t("filters.apply")}
        </Button>
      </div>
    </div>
  );
};
